import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, TextField, Switch, FormControlLabel, Tabs, Tab, Select, MenuItem } from '@mui/material';

export default function AntihackerPage() {
  const [tab, setTab] = useState('alerts');
  const [stats, setStats] = useState({total_alerts:0, total_blocks:0, last_run:'', enabled:false});
  const [alerts, setAlerts] = useState([]);
  const [blocked, setBlocked] = useState([]);
  const [settings, setSettings] = useState({});
  const [apiKey, setApiKey] = useState('');
  const [aiModels, setAiModels] = useState({claude:[], openai:[]});
  const [msg, setMsg] = useState('');
  const tok = localStorage.getItem('dashboard_token');

  const load = () => {
    fetch('/api/antihacker/stats', { headers:{Authorization:'Bearer '+tok} })
      .then(r=>r.json()).then(d=>setStats(d || {}));
    fetch('/api/antihacker/alerts', { headers:{Authorization:'Bearer '+tok} })
      .then(r=>r.json()).then(d=>setAlerts(d || []));
    fetch('/api/antihacker/blocked', { headers:{Authorization:'Bearer '+tok} })
      .then(r=>r.json()).then(d=>setBlocked(d || []));
    fetch('/api/ai-models', { headers:{Authorization:'Bearer '+tok} }).then(r=>r.json()).then(d=>setAiModels(d || {claude:[], openai:[]}));
    fetch('/api/antihacker/settings', { headers:{Authorization:'Bearer '+tok} })
      .then(r=>r.json()).then(d=>{ setSettings(d || {}); setApiKey(d?.abuseipdb || ''); });
  };
  useEffect(() => { load(); const i = setInterval(load, 30000); return () => clearInterval(i); }, []);

  const updateSetting = async (key, value) => {
    await fetch('/api/antihacker/settings/'+key, {
      method:'POST', headers:{Authorization:'Bearer '+tok, 'Content-Type':'application/json'},
      body: JSON.stringify({value: String(value)})
    });
    setMsg('💾 Збережено'); setTimeout(()=>setMsg(''),2000); load();
  };

  const saveKey = async () => {
    await fetch('/api/api-keys/abuseipdb?key='+encodeURIComponent(apiKey), {
      method:'POST', headers:{Authorization:'Bearer '+tok}
    });
    setMsg('🔑 Ключ збережено'); setTimeout(()=>setMsg(''),3000);
  };

  const unblockIp = async (ip) => {
    if(!window.confirm('Розблокувати '+ip+'?')) return;
    await fetch('/api/antihacker/unblock?ip='+encodeURIComponent(ip), {
      method:'POST', headers:{Authorization:'Bearer '+tok}
    });
    setMsg('✅ Розблоковано'); setTimeout(()=>setMsg(''),2000); load();
  };

  const runNow = async () => {
    setMsg('⏳ Запускаю перевірку...');
    await fetch('/api/antihacker/run', {
      method:'POST', headers:{Authorization:'Bearer '+tok}
    });
    setMsg('✅ Виконано'); setTimeout(()=>setMsg(''),3000); load();
  };

  return (
    <Box sx={{p:3}}>
      <Typography variant="h5" sx={{color:'#FFD700',mb:3}}>🛡 Антихакер</Typography>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #f44336',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#f44336',mb:2}}>📊 Стан системи</Typography>
        <Box sx={{display:'flex',gap:3,flexWrap:'wrap'}}>
          <Box><Typography sx={{color:'#aaa',fontSize:13}}>Всього алертів</Typography><Typography sx={{color:'#f44336',fontSize:32,fontWeight:'bold'}}>{stats.total_alerts || 0}</Typography></Box>
          <Box><Typography sx={{color:'#aaa',fontSize:13}}>Заблоковано IP</Typography><Typography sx={{color:'#FFD700',fontSize:32,fontWeight:'bold'}}>{stats.total_blocks || 0}</Typography></Box>
          <Box><Typography sx={{color:'#aaa',fontSize:13}}>Активні блоки</Typography><Typography sx={{color:'#4caf50',fontSize:32,fontWeight:'bold'}}>{blocked.length || 0}</Typography></Box>
          <Box><Typography sx={{color:'#aaa',fontSize:13}}>Останній запуск</Typography><Typography sx={{color:'#fff',fontSize:14,mt:1}}>{stats.last_run ? new Date(stats.last_run + 'Z').toLocaleString() : 'ніколи'}</Typography></Box>
        </Box>
        <Box sx={{display:'flex',gap:2,mt:2,flexWrap:'wrap'}}>
          <Button variant="contained" onClick={runNow} sx={{bgcolor:'#f44336'}}>▶ Запустити перевірку</Button>
        </Box>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #2196f3',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#2196f3',mb:2}}>🔑 AbuseIPDB API ключ</Typography>
        <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
          <TextField fullWidth size="small" type="password" value={apiKey} onChange={e=>setApiKey(e.target.value)}
            placeholder="Ваш AbuseIPDB API ключ" sx={{'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
          <Button variant="contained" onClick={saveKey} sx={{bgcolor:'#2196f3',whiteSpace:'nowrap'}}>💾 Зберегти</Button>
        </Box>
        <Typography sx={{color:'#888',fontSize:12,mt:1}}>Безкоштовний tier: 1000 перевірок/день. Отримати ключ: abuseipdb.com/account/api</Typography>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #4caf50',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#4caf50',mb:2}}>⚙️ Налаштування</Typography>
        <FormControlLabel control={<Switch checked={settings.anti_hacker_enabled === 'true'} onChange={e=>updateSetting('anti_hacker_enabled', e.target.checked ? 'true' : 'false')}/>}
          label={<Typography sx={{color:'#fff'}}>Увімкнути Антихакер</Typography>}/>
        <FormControlLabel control={<Switch checked={settings.anti_hacker_auto_block === 'true'} onChange={e=>updateSetting('anti_hacker_auto_block', e.target.checked ? 'true' : 'false')}/>}
          label={<Typography sx={{color:'#fff'}}>Автоблокування підозрілих IP</Typography>}/>
        <FormControlLabel control={<Switch checked={settings.anti_hacker_notify_telegram === 'true'} onChange={e=>updateSetting('anti_hacker_notify_telegram', e.target.checked ? 'true' : 'false')}/>}
          label={<Typography sx={{color:'#fff'}}>Сповіщення в Telegram</Typography>}/>
        <Box sx={{display:'flex',gap:2,mt:2,flexWrap:'wrap'}}>
          <TextField size="small" type="number" label="Min Abuse Score" value={settings.anti_hacker_min_score || 75}
            onChange={e=>updateSetting('anti_hacker_min_score', e.target.value)}
            sx={{width:140,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
          <TextField size="small" type="number" label="Max Failed Attempts" value={settings.anti_hacker_max_failed_attempts || 5}
            onChange={e=>updateSetting('anti_hacker_max_failed_attempts', e.target.value)}
            sx={{width:160,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
          <Select size="small" value={settings.anti_hacker_model || 'claude-haiku-4-5-20251001'}
            onChange={e=>updateSetting('anti_hacker_model', e.target.value)}
            MenuProps={{PaperProps:{sx:{bgcolor:'#fff', maxHeight:400}}}}
            sx={{minWidth:240,color:'#fff'}}>
            <MenuItem disabled sx={{color:'#666',fontWeight:'bold'}}>🤖 Claude (Anthropic)</MenuItem>
            {aiModels.claude && aiModels.claude.map(m => (
              <MenuItem key={m.id} value={m.id} sx={{color:'#000',bgcolor:'#fff','&:hover':{bgcolor:'#FFD700'}}}>
                🤖 {m.name}
              </MenuItem>
            ))}
            <MenuItem disabled sx={{color:'#666',fontWeight:'bold'}}>🧠 OpenAI GPT</MenuItem>
            {aiModels.openai && aiModels.openai.slice(0,15).map(m => (
              <MenuItem key={m.id} value={m.id} sx={{color:'#000',bgcolor:'#fff','&:hover':{bgcolor:'#FFD700'}}}>
                🧠 {m.name}
              </MenuItem>
            ))}
            <MenuItem value="both" sx={{color:'#000',bgcolor:'#fff','&:hover':{bgcolor:'#FFD700'}}}>🤝 Claude + GPT (порівняти)</MenuItem>
          </Select>
        </Box>
      </Paper>

      <Tabs value={tab} onChange={(e,v)=>setTab(v)} sx={{mb:2,'& .MuiTab-root':{color:'#aaa'},'& .Mui-selected':{color:'#FFD700'}}}>
        <Tab value="alerts" label={"⚠️ Алерти ("+alerts.length+")"}/>
        <Tab value="blocked" label={"🚫 Заблоковані IP ("+blocked.length+")"}/>
      </Tabs>

      {tab === 'alerts' && (alerts.length === 0 ? (
        <Paper sx={{bgcolor:'#1a1a2e',p:3,textAlign:'center',color:'#aaa'}}>Немає алертів</Paper>
      ) : alerts.map(a => (
        <Paper key={a.id} sx={{bgcolor:'#1a1a2e',border:'2px solid '+(a.abuse_score >= 90 ? '#f44' : a.abuse_score >= 75 ? '#ff9800' : '#4caf50'),p:2,mb:2}}>
          <Box sx={{display:'flex',justifyContent:'space-between',mb:1,flexWrap:'wrap'}}>
            <Box>
              <Typography sx={{color:'#FFD700',fontSize:15,fontWeight:'bold'}}>🌐 {a.ip_address}</Typography>
              <Typography sx={{color:'#aaa',fontSize:12}}>{a.country_name} | {a.isp}</Typography>
            </Box>
            <Box sx={{textAlign:'right'}}>
              <Typography sx={{color:a.abuse_score >= 75 ? '#f44' : '#FFD700',fontSize:18,fontWeight:'bold'}}>Score: {a.abuse_score}%</Typography>
              <Typography sx={{color:'#aaa',fontSize:11}}>{new Date(a.created_at + 'Z').toLocaleString()}</Typography>
            </Box>
          </Box>
          <Typography sx={{color:'#fff',fontSize:13}}>🎯 {a.threat_type} | Невдалих спроб: {a.failed_attempts || 0}</Typography>
          {a.ai_verdict && <Paper sx={{bgcolor:'#0a0a0a',p:1.5,mt:1,border:'1px solid #444'}}>
            <Typography sx={{color:'#4caf50',fontSize:12}}>🤖 {a.ai_model || 'AI'}: {a.ai_verdict}</Typography>
          </Paper>}
          {a.action_taken && <Typography sx={{color:'#ff9800',fontSize:12,mt:1}}>⚡ Дія: {a.action_taken}</Typography>}
        </Paper>
      )))}

      {tab === 'blocked' && (blocked.length === 0 ? (
        <Paper sx={{bgcolor:'#1a1a2e',p:3,textAlign:'center',color:'#aaa'}}>Немає заблокованих IP</Paper>
      ) : blocked.map(b => (
        <Paper key={b.ip_address} sx={{bgcolor:'#1a1a2e',border:'1px solid #f44336',p:2,mb:2}}>
          <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap'}}>
            <Box>
              <Typography sx={{color:'#FFD700',fontSize:15,fontWeight:'bold'}}>🚫 {b.ip_address}</Typography>
              <Typography sx={{color:'#aaa',fontSize:12}}>{b.reason} | Score: {b.abuse_score}%</Typography>
              <Typography sx={{color:'#888',fontSize:11}}>{b.permanent ? '♾ Назавжди' : 'до '+(b.expires_at ? new Date(b.expires_at + 'Z').toLocaleString() : '?')}</Typography>
            </Box>
            <Button onClick={()=>unblockIp(b.ip_address)} variant="outlined" sx={{borderColor:'#4caf50',color:'#4caf50'}}>✅ Розблокувати</Button>
          </Box>
        </Paper>
      )))}

      {msg && <Typography sx={{color:'#4caf50',position:'fixed',bottom:20,right:20,bgcolor:'#1a1a2e',p:2,borderRadius:2,zIndex:9999}}>{msg}</Typography>}
    </Box>
  );
}
